import { Routes } from "@angular/router";
import { WorkflowEndcustomerAiTariffOrderCancelComponent } from "./workflow-endcustomer-ai-tariff-order-cancel.component";

export const WorkflowEndcustomerAiTariffOrderCancelRouting: Routes = [
    {
        path: 'change-ai-tariff/:aid/order-cancel', component: WorkflowEndcustomerAiTariffOrderCancelComponent
    },
]